import React from 'react';
import { XCircle, AlertTriangle } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Tenés que preparar clases desde cero todo el tiempo', 'Perdés horas armando material que podrías reutilizar', 'Te cuesta organizar los temas para todo el año', 'Terminás improvisando por falta de tiempo', 'No tenés una base de material lista para usar en tus clases'];
  return <section className="py-12 px-6 bg-[#0f0f23]" data-id="element-180">
      <div className="flex justify-center mb-6" data-id="element-181">
        <div className="bg-red-500/10 p-3 rounded-full" data-id="element-182">
          <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-183" />
        </div>
      </div>

      <h2 className="text-2xl font-bold text-center mb-8 leading-tight" data-id="element-184">
        Si sos docente de matemática, vivís esto a diario…
      </h2>

      <div className="space-y-4 mb-8" data-id="element-185">
        {problems.map((problem, index) => <div key={index} className="flex items-start gap-3 bg-white/5 p-4 rounded-xl border border-white/5" data-id="element-186">
            <XCircle className="w-5 h-5 text-red-500 shrink-0 mt-0.5" data-id="element-187" />
            <p className="text-gray-300 text-sm leading-relaxed" data-id="element-188">{problem}</p>
          </div>)}
      </div>

      <div className="bg-red-900/20 border border-red-500/20 rounded-xl p-6 text-center" data-id="element-189">
        <p className="font-bold text-red-400 mb-2" data-id="element-190">Y lo peor…</p>
        <p className="text-gray-200" data-id="element-191">
          Sentís que trabajás todo el tiempo… pero nunca terminás de estar
          organizado.
        </p>
      </div>
    </section>;
}